import React from 'react'
import { DuplicateIcon, HeartIcon } from '@heroicons/react/solid';
import { copyToClipboard } from '../../Functions/CopyToClipboard/CopyToClipboard';
import { approveOutreach } from '../../Functions/ApproveOutreach/ApproveOutreach';
import CopyHK from '../../Functions/Hotkeys/CopyHK';
import YesOrNoHK from '../../Functions/Hotkeys/FireHK';


function CopyAndFireButtons({
    contentGen,
    generating,
    fbProfile,
    docId,
    vProp,
    intVal,
    shownButton,
    firstCopy,
    profile,
    setBtnClicked,
    auth,
    fireClicked
}) {
    return (
        <div>
        {contentGen !== '' && generating !== true ?
            <div className="mr-auto flex">
                <button 
                className="bg-green-600 text-white ml-6 text-base h-10 my-2 p-2 rounded font-semibold border-2 border-green-600 focus:outline-none focus:bg-green-800 hover:bg-green-700"
                onClick={() => copyToClipboard(
                    contentGen,
                    fbProfile,
                    docId,
                    vProp,
                    intVal,
                    shownButton,
                    firstCopy,
                    profile, 
                    auth
                )}
                >
                <span className='flex'><DuplicateIcon className="h-5 mr-2"/> Copy</span>
                </button>
                <CopyHK 
                copyFunc={() => copyToClipboard(
                    contentGen,
                    fbProfile,
                    docId,
                    vProp,
                    intVal,
                    shownButton,
                    firstCopy,
                    profile, 
                    auth
                )}
                />
                {fireClicked ? null :
                <div>
                <button 
                className="bg-red-500 text-white ml-3 text-base h-10 my-2 p-2 rounded font-semibold border-2 border-red-500 focus:outline-none focus:bg-red-800 hover:bg-red-700"
                onClick={() => approveOutreach(
                    fbProfile,
                    contentGen,
                    intVal,
                    vProp,
                    docId,
                    shownButton,
                    setBtnClicked,
                    profile,
                    auth
                )}
                >
                    <span className='flex'><HeartIcon className="h-5 mr-2"/> Save Message</span>
                </button>
                <YesOrNoHK 
                accepted={() => approveOutreach(
                    fbProfile,
                    contentGen,
                    intVal,
                    vProp,
                    docId,
                    shownButton,
                    setBtnClicked,
                    profile,
                    auth
                )}
                />
                </div>
                }
            </div>
            : 
            null }
        </div>
    )
}

export default CopyAndFireButtons
